import createDynamicDirective from './utils/dynamic-directive-creator'
import englishDirective from './directives/english'
import japaneseDirective from './directives/japanese'
import mathDirecctive from './directives/math'
import '../../css/hand-writing.css'

window.createDynamicDirective = createDynamicDirective;

japaneseDirective();
englishDirective();
mathDirecctive();
